export const CONTAINER = {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const FORM = {
    display: 'flex',
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "space-around",
    width: 400,
}